/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Overwrite_ButtonInputs */

const en_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite`)
};

const fr_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecraser`)
};

const de_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überschreiben`)
};

const it_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrascrivi`)
};

const ru_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезаписать`)
};

const es_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exagerar`)
};

const zh_cn2_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖`)
};

const ja_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上書き`)
};

const hi_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरराइट`)
};

const pt_pt2_explorer_display_overwrite_button = /** @type {(inputs: Explorer_Display_Overwrite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescrever`)
};

/**
* | output |
* | --- |
* | "Overwrite" |
*
* @param {Explorer_Display_Overwrite_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_overwrite_button = /** @type {((inputs?: Explorer_Display_Overwrite_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Overwrite_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_overwrite_button(inputs)
	if (locale === "de") return de_explorer_display_overwrite_button(inputs)
	if (locale === "it") return it_explorer_display_overwrite_button(inputs)
	if (locale === "ru") return ru_explorer_display_overwrite_button(inputs)
	if (locale === "es") return es_explorer_display_overwrite_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_overwrite_button(inputs)
	if (locale === "ja") return ja_explorer_display_overwrite_button(inputs)
	if (locale === "hi") return hi_explorer_display_overwrite_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_overwrite_button(inputs)
	return en_explorer_display_overwrite_button(inputs)
});